enum CustomFieldType {
  CHECKBOX = "CHECKBOX",
  LIST = "LIST",
  RADIO = "RADIO",
  TEXT = "TEXT",
  ALLOCATION = "ALLOCATION",
}

export default CustomFieldType;
